<template>
  <div class="search-wrapper">
    <h2 class="h2-header">Quickfinder®</h2>
    <v-text-field
      v-model="rawUrl"
      label="URL mit IDs (Kunde, Kampagne, Lead)"
      variant="outlined"
      density="compact"
      hide-details="true"
      single-line
      rounded="lg"
      class="search-input"
    ></v-text-field>

    <v-btn
      v-if="parsedIds.customer"
      class="search-btns gradient-color-primary"
      rounded="lg"
      :to="`/customer/${parsedIds.customer}`"
      prepend-icon="mdi-open-in-app"
    >
      Kunde
    </v-btn>

    <v-btn
      v-if="parsedIds.table"
      class="search-btns gradient-color-primary"
      rounded="lg"
      :to="`/table/${parsedIds.table}`"
      prepend-icon="mdi-open-in-app"
    >
      Kampagne
    </v-btn>

    <v-btn
      v-if="parsedIds.lead"
      class="search-btns gradient-color-primary"
      rounded="lg"
      :to="`/lead/${parsedIds.lead}`"
      prepend-icon="mdi-open-in-app"
    >
      Lead
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "LinkNavigator",
  data() {
    return {
      rawUrl: "",
    };
  },
  computed: {
    parsedIds() {
      const result = {
        customer: null,
        table: null,
        lead: null,
      };

      if (!this.rawUrl) return result;

      try {
        const url = new URL(this.rawUrl);
        const segments = url.pathname.split("/");

        const customerIndex = segments.indexOf("customer");
        const tableIndex = segments.indexOf("table");

        if (customerIndex > -1) result.customer = segments[customerIndex + 1];
        if (tableIndex > -1) result.table = segments[tableIndex + 1];

        const lead = url.searchParams.get("lead");
        if (lead) result.lead = lead;
      } catch (e) {
        // Invalid URL
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>

.search-input {
  background-color: white;
  border-radius: 12px;
}

</style>
